import { render, staticRenderFns } from "./bpiInProcessing.vue?vue&type=template&id=6dc51b08&"
import script from "./bpiInProcessing.vue?vue&type=script&lang=js&"
export * from "./bpiInProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports